import Layout from '@/layout/index'
import Map from '@/view/map/map'

const routes = [
    {
        path: '/',
        component: Layout,
        hidden: true,
        title: '',
        icon: 'dashboard',
        redirect: "/home/index"
    },
    {
        path: '/home',
        name: 'home',
        component: Layout,
        children: [{
            path: 'index',
            component: () => import('@/view/home'),
            title: '首页',
            icon: 'icon-gongneng',
            img:'home'
        }]
    },
    {
        path: '/insight',
        name: 'insight',
        component: Layout,
        title: '市场洞察',
        icon: 'icon-quanxianshezhi',
        img:'urban',
        children: [{
            path: 'urbanAgglomerations',
            component: () => import('@/view/insight/urbanAgglomerations/index.vue'),
            title: '城市群洞察',
        }, {
            path: 'project',
            component: () => import('@/view/insight/project/index.vue'),
            title: '项目洞察',
        }, {
            path: 'urban',
            component: () => import('@/view/insight/urban/index'),
            title: '城市洞察',
        }, {
            path: 'marketReport',
            component: () => import('@/view/insight/marketReport/index'),
            title: '市场报告',
        }]
    },
    {
        path: '/exportData',
        name: 'exportData',
        component: Layout,
        title: '数据导出',
        img:'export',
        children: [
            {
                path: 'project',
                component: () => import(/* webpackChunkName: "exportData" */ '@/view/exportData/project/project.vue'),
                title: '项目数据',
            },{
                path: 'city',
                component: () => import(/* webpackChunkName: "exportData" */ '@/view/exportData/city/city.vue'),
                title: '城市数据',
            }
        ]
    },
    {
        path: '/map',
        title: '',
        icon: 'map',
        hidden: true,
        component: Map
    },
    {
        path: '/login',
        title: '',
        icon: 'Login',
        hidden: true,
        component: () => import(/* webpackChunkName: "login" */ '@/view/login/index.vue')
    },
    {
        path: '/comparison',
        title: '',
        hidden: true,
        component: () => import(/* webpackChunkName: "comparison" */ '@/view/comparison/index.vue')
    }
]

export default routes